import api from '@/helpers/api';

export default {
    inserted: (el) => {
        const loadImage = async () => {
            const imageElement = Array.from(el.children).find(
                it => it.nodeName === 'IMG'
            );

            if (imageElement) {
                imageElement.addEventListener('error', (err) => { throw err; });
                const { url } = imageElement.dataset;
                const { data } = await api(url, { responseType: 'arraybuffer' });
                const buffer = Buffer.from(data, 'binary').toString('base64');
                imageElement.src = `data:image/jpeg;base64,${buffer}`;
            }
        };

        function handleIntersect(entries, observer) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    loadImage();
                    observer.unobserve(el);
                }
            });
        }

        const options = {
            // circumstances under which the observer's callback is invoked
            root: null, // defaults to the browser viewport if not specified or if null
            threshold: 0 // the degree of intersection between the target element and its root (0 - 1)
            // threshold of 1.0 means that when 100% of the target is visible within
            // the element specified by the root option, the callback is invoked
        };

        // Whether you're using the viewport or some other element as the root,the API works the same way,
        // executing a callback function you provide whenever the visibility of the target element changes
        // so that it crosses desired amounts of intersection with the root

        const observer = new IntersectionObserver(handleIntersect, options);

        observer.observe(el); // target element to watch
    }
};
